import AOS from 'aos';

AOS.init({
	disable: 'mobile',
	once: true,
	offset: 0,
});

$('.page').each((index, element) => {
	let $component = $(element);

	$component.on('page:show', () => {
		$component.removeClass('hidden');
		$('.aos-animate').removeClass('aos-animate');
		AOS.refreshHard();
	});

	$component.on('page:hide', () => {
		$component.addClass('hidden');
		$('.aos-animate').removeClass('aos-animate');
		AOS.refreshHard();
	});
});
